<template>
  <div>
    <ul>
      <li
        :id="'li' + index"
        :key="index"
        :style="{
          left:
            (index * (4 - chartData.data.length * 0.3)) /
              chartData.data.length +
            0.3 * index +
            'rem'
        }"
        v-for="(item, index) in chartData.data"
      >
        <div class="pian"></div>
        <div class="top">
          {{ Math.round((item.count / chartData.total) * 100) + "%" }}
        </div>
        <div class="down">{{ item.name }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Bar3d",
  props: {
    chartData: {
      type: Object
    }
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {
    setTimeout(() => {
      this.chartData.data.forEach((item, index) => {
        document.getElementById("li" + index).style.height =
          (item.count / this.chartData.max) * 100 + "%";
      });
    }, 500);
  },
  methods: {}
};
</script>
<style scoped lang="less">
ul {
  width: 100%;
  height: 1.8rem;
  position: relative;
  li {
    width: 0.3rem;
    height: 0%;
    background: #279abf;
    float: left;
    position: absolute;
    bottom: 0;
    transition: all 0.5s;
    color: #fff;
    white-space: nowrap;
    .top {
      position: absolute;
      top: -0.36rem;
      left: 0;
    }
    .down {
      position: absolute;
      bottom: -0.36rem;
      left: 50%;
      transform: translateX(-50%);
      font-size: 0.15rem;
    }
  }
  li .pian {
    position: absolute;
    width: 0.15rem;
    height: 100%;
    background: #0f5c86;
    right: 0;
    top: 0;
  }
  li::before {
    content: "";
    position: absolute;
    z-index: 9;
    width: 0.3rem;
    height: 0.14rem;
    background: url(../../assets/youkequntihuaxiang/lengxing2.png);
    background-size: 100%;
    left: 0;
    bottom: -0.07rem;
  }
  li::after {
    content: "";
    position: absolute;
    width: 0.3rem;
    height: 0.14rem;
    background: url(../../assets/youkequntihuaxiang/lengxing.png);
    background-size: 100%;
    left: 0;
    top: -0.07rem;
  }
}
</style>
